import gql from 'graphql-tag';

export const GET_DEVICES = gql`
  query getDevices($name: ServiceProviderName!) {
    serviceProvider(name: $name) {
      devices {
        deviceType
        deviceId
        deviceName
      }
    }
  }
`;

export const QUERY_TRIGGER_SETTINGS = gql`
  query triggerSettings($deviceUuid: String!, $action: ServiceProviderWithAction!, $targetId: String!) {
    getTriggers(triggerGroup: { deviceUuid: $deviceUuid, action: $action, targetId: $targetId }) {
      groupId {
        deviceUuid
        action
        targetId
      }
      triggers {
        id
        settings {
          sensorType
          threshold
          thresholdType
          duration
        }
      }
    }
  }
`;

export const SET_TRIGGER_SETTINGS = gql`
  mutation setTriggerSettings($triggerGroup: TriggerGroupIdInput!, $triggerSettingsList: [TriggerSettingInput!]!) {
    setTriggers(triggerGroup: $triggerGroup, triggerSettingsList: $triggerSettingsList)
  }
`;

export const DISCONNECT_SERVICE_PROVIDER = gql`
  mutation disconnectServiceProvider($name: ServiceProviderName!, $deviceUuid: String!) {
    disconnectServiceProvider(name: $name, deviceUuid: $deviceUuid)
  }
`;



// WEBPACK FOOTER //
// ./src/lib/graphQL/thermostats/queries.js